<template>
  <modal adaptive class="z-50" name="redeemcouponcode" :clickToClose="true" height="auto" :scrollable="true">
    <h3 class="headline-extras">Du hast einen Gutschein? Löse ihn ein!</h3>

    <div v-if="response != ''" class="my-4 flex items-center bg-green-heinz text-white text-sm font-bold px-4 py-3" role="alert">
      <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
      <p v-html="response"></p>
    </div>

    <div class="w-full" @keydown.enter="redeem">
      <div class="w-full">
        <label class="block text-grey font-bold mb-1 md:mb-0 pr-4" for="couponcode">
          Dein Gutscheincode:
        </label>
      </div>
      <div class="w-full">
        <input v-model="couponcode" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" id="couponcode" type="text" placeholder="" />
      </div>
      <div class="w-full mt-4">
        <button @click.prevent="redeem" class="shadow bg-green-heinz hover:bg-green-heinz-dark text-white font-bold py-2 px-4 rounded" type="button">
          Weiter!
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'Couponcode',

  data () {
    return {
      couponcode: '',
      response: ''
    }
  },

  created () {
    window.eventBus.$on('addCoupon', () => {
      this.$modal.show('redeemcouponcode')

      const isIE11 = (!!window.MSInputMethodContext && !!document.documentMode)
      if (!isIE11) {
        window.setTimeout(() => {
          document.getElementById('couponcode').focus()
        }, 500)
      }
    })
  },

  methods: {
    ...mapActions([
      'updateBasket'
    ]),

    redeem: function () {
      axios.post(endpoints.redeemCoupon, {
        couponCode: this.couponcode,
        isv3: true
      })
        .then(response => {
          this.response = response.data
          this.updateBasket()
          window.eventBus.$emit('reloadDeliveryOptions')
          setTimeout(() => { this.$modal.hide('redeemcouponcode') }, 1500)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .headline-extras {
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Couponcode.vue